<template>
  <div class="modal fade" id="ranking-modal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog modalBox" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
            <h4 class="modal-title"><i class="fa fa-info-circle mr-5"></i>Punktzahlberechnung</h4>
        </div>
        <div class="modal-body" id="modalBody">
          <p>
            <strong>Ihre Verkäuferstatus-Farbe („Ampel-Farbe“):</strong>
          </p>
          <p>
            - Die Farbe Ihres Verkäuferstatus orientiert sich an einem Ampel-Ranking GRÜN – GELB – ROT<br/>
            - Die Zuweisung von Bestellungen für die externen Marktplätze erfolgt ausschließlich über die „Ampel-Farbe“ hierarchisch nach 1. GRÜN, 2. GELB und 3. ROT<br/>
            <span class="space">- GRÜN: Wenn Sie durchschnittlich am 1. Tag eine Bestellung versenden oder eine Retoure vereinnahmen</span><br/>
            <span class="space">- GELB: Wenn Sie durchschnittlich am 2. Tag eine Bestellung versenden oder eine Retoure vereinnahmen</span><br/>
            <span class="space">- ROT: Andernfalls befinden Sie sich in dieser Kategorie</span><br/>
            - Innerhalb der jeweiligen „Ampel-Farbe“ wird nach dem Zufallsprinzip zugewiesen<br/>
            - Es zählen die letzten 30 Tage<br/>
            - selber Tag = Reaktion auf Bestellungen mit Bestelleingang vor 14 Uhr noch am gleichen Tag, Bestellungen nach 14 Uhr bis zum Folgetag 14 Uhr<br/>
            - Sonntage und bundesweite Feiertage sind nicht als Tag zu betrachten<br/>
          </p>
          <strong>
            Die Bestellpunkte berechnen sich wie folgt:<br/>
          </strong><br/>
          <p>
            <strong>Versendungen:</strong><br/>
            - Versand am selben Tag: 3 Punkte<br/>
            - Versand am 1. Tag: 2 Punkte<br/>
            - Versand am 2. Tag: 0.5 Punkte<br/>
            - Versand am 3. Tag: -10 Punkte<br/>
            - Versand am 4. Tag: -50 Punkte<br/>
            - Versand ab 5. Tag: Tage * -25 Punkte<br/>
          </p>
          <p>
            Bei einer Preisdifferenz <strong>über 10%</strong> beim Versand wird die Differenz als Punkte gutgeschrieben (1€ = 1 Punkt).
          </p>
          <p>
            <strong>Stornierungen:</strong><br/>
            - Storno am selben Tag: -100 Punkte<br/>
            - Storno an späteren Tagen: Tage * -100 Punkte<br/>
          </p>
          <p>
            Bei einer Stornierung eines Artikels mit einer Preisdifferenz <strong>über 15%</strong> am ersten Tag werden keine Minuspunkte vergeben.
          </p>
          <p>
            <strong>Retouren:</strong><br/>
            - Retoure am selben Tag: 3 Punkte<br/>
            - Retoure am 1. Tag: 2 Punkte<br/>
            - Retoure am 2. Tag: 0.5 Punkte<br/>
            - Retoure am 3. Tag: -10 Punkte<br/>
            - Retoure am 4. Tag: -50 Punkte<br/>
            - Retoure ab 5. Tag: Tage * -25 Punkte<br/>
          </p>
          <p>
            Bitte informieren Sie den Customer Service, sollte ein falscher, getragener oder reklamierter Artikel zurückgesendet werden, sodass keine Punkte für die Retoure vergeben werden.
          </p>
        </div>
        <div class="modal-footer modalBox">
          <button type="button" class="btn bg-danger btn-app" data-dismiss="modal"><span class="fa fa-times "></span>{{'cancel' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    this.$nextTick(() => {
    })
  }
}
</script>
<style>
#modalBody {
  height: 43rem;
  width: 48rem;
  overflow: scroll;
}
.modalBox {
  width: 48.15rem;
}
.space {
  padding-left: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/tools/Modals/RankingModal.vue